<template>
  <span class="slidepoise-cover" aria-hidden="true">
    <span class="slidepoise-cover-kicker">OPEN-SOURCE PRESENTATION SKILL</span>
    <span class="slidepoise-cover-brand"><img src="/assets/video/slidepoise/mark.svg" width="112" height="112" alt="" draggable="false" /><span class="slidepoise-cover-name">SlidePoise</span></span>
    <span class="slidepoise-cover-slogan">Let the content shape the slide.</span>
  </span>
</template>

<style src="../../../public/assets/video/slidepoise/cover.css"></style>
